export default __webpack_public_path__ + "static/media/logo.ffc2a9f2.png";